import * as tslib_1 from "tslib";
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { shallowCompare } from 'office-ui-fabric-react/lib/Utilities';
import { isFolderInFavorites, isPublicFolderInFavorites, ToggleFavoriteButton, } from 'owa-favorites';
import { lazyToggleFavoriteFolder } from 'owa-mail-folder-forest-actions';
import { lazyRemovePublicFolderFromFavorites } from 'owa-publicfolder-picker';
import { selectFolder } from 'owa-mail-folder-forest-actions';
import { getSelectedNode } from 'owa-mail-folder-forest-store';
import isArchiveFolder from 'owa-mail-folder-store/lib/utils/isArchiveFolder';
import folderStore from 'owa-folders';
import publicFolderFavoriteStore from 'owa-public-folder-favorite/lib/store/publicFolderFavoriteStore';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import strings from 'owa-strings/owa-mail-strings';
import TreeNode from 'owa-tree-node/lib/components/TreeNode';
import * as React from 'react';
import { default as viewStateStore } from 'owa-mail-folder-store/lib/store/store';
import { store as bulkActionStore, isBulkActionUninitialized, isBulkActionRunning, } from 'owa-bulk-action-store';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import getBulkActionTooltipText from '../selectors/getBulkActionTooltipText';
import { isFavoritingInProgress } from 'owa-mail-favorites-store';
var mailFolderNodeStyles = require('./MailFolderNode.scss');
var classNames = require('classnames/bind').bind(mailFolderNodeStyles);
// Folders that should show total count instead of unread count
var FOLDERS_TO_SHOW_TOTALCOUNT = [
    'drafts',
    'junkemail',
    'outbox',
    'notes',
    'scheduled',
];
// Mobx does not support as of 8/29/2016 @computed in FolderNode,
// because it needs to be part of a view model class. This is our
// workaround in order to use computed properties.
var FolderNodeComputedState = /** @class */ (function () {
    function FolderNodeComputedState(props) {
        this.props = props;
    }
    Object.defineProperty(FolderNodeComputedState.prototype, "isSelected", {
        get: function () {
            var selectedNode = getSelectedNode();
            return (this.props.treeType == selectedNode.treeType && this.props.folderId == selectedNode.id);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FolderNodeComputedState.prototype, "isWithContextMenuOpen", {
        get: function () {
            return this.props.folderId == viewStateStore.withContextMenuFolderId;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        computed
    ], FolderNodeComputedState.prototype, "isSelected", null);
    tslib_1.__decorate([
        computed
    ], FolderNodeComputedState.prototype, "isWithContextMenuOpen", null);
    return FolderNodeComputedState;
}());
var FolderNode = /** @class */ (function (_super) {
    tslib_1.__extends(FolderNode, _super);
    function FolderNode(props) {
        var _this = _super.call(this, props) || this;
        _this.renderRightCharmHover = function (shouldShowBulkActionsSpinner) {
            return shouldShowBulkActionsSpinner ? (_this.renderBulkActionSpinner()) : !!_this.props.shouldHideToggleFavorite ? (_this.renderUnreadOrTotalCount()) : (React.createElement(ToggleFavoriteButton, { isInFavorites: _this.isFolderOrPublicFolderInFavorites(), onClick: _this.toggleFavoriteState, iconStyles: mailFolderNodeStyles.favoriteButton }));
        };
        _this.renderBulkActionSpinner = function () {
            var bulkActionInfo = bulkActionStore.bulkActionInformationMap.get(_this.props.folderId);
            var scenario = bulkActionInfo.customData
                ? JSON.parse(bulkActionInfo.customData).Scenario
                : bulkActionInfo.class;
            return (React.createElement(TooltipHost, { content: getBulkActionTooltipText(scenario, _this.props.folderId), calloutProps: { gapSpace: 0 } },
                React.createElement(Spinner, { size: SpinnerSize.small, title: "" })));
        };
        _this.toggleFavoriteState = function (evt) {
            evt.stopPropagation();
            var folder = _this.getFolder();
            if (isFavoritingInProgress(_this.props.folderId)) {
                // Do nothing: favoriting is in progress
                return;
            }
            if (_this.props.isPublicFolder) {
                _this.toggleFavoritePublicFolder(folder);
            }
            else {
                lazyToggleFavoriteFolder.importAndExecute(folder, 'FolderNodeFavoriteButton');
            }
        };
        _this.toggleFavoritePublicFolder = function (folder) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var removePublicFolderFromFavorites;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, lazyRemovePublicFolderFromFavorites.import()];
                    case 1:
                        removePublicFolderFromFavorites = _a.sent();
                        removePublicFolderFromFavorites(folder);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.renderUnreadOrTotalCount = function () {
            var folderId = _this.props.folderId;
            var folder = _this.getFolder();
            var shouldDisplayTotalCount = FOLDERS_TO_SHOW_TOTALCOUNT.indexOf(folderIdToName(folderId)) >= 0 &&
                folder.TotalCount > 0;
            var count = shouldDisplayTotalCount ? folder.TotalCount : folder.UnreadCount;
            count = count == 0 ? null : count; // We do not display the number 0;
            var unreadCountClassNames = classNames(mailFolderNodeStyles.unreadOrTotalCount, !shouldDisplayTotalCount && mailFolderNodeStyles.unreadCount);
            return (React.createElement("span", { className: unreadCountClassNames },
                count,
                React.createElement("span", { className: "screenReaderOnly" }, // for a treeitem, inner content that have aria-hidden=true are not hidden in IE
                // therefore we cannot hide the visual string and use a screenReaderOnly string that has the count
                shouldDisplayTotalCount
                    ? count == 1
                        ? strings.itemCountSingularScreenReaderOnlyText
                        : strings.itemCountPluralScreenReaderOnlyText
                    : strings.unreadCountScreenReaderOnlyText)));
        };
        _this.getFolder = function () {
            if (_this.props.isPublicFolder) {
                return publicFolderFavoriteStore.folderTable.get(_this.props.folderId);
            }
            return folderStore.folderTable.get(_this.props.folderId);
        };
        _this.isFolderOrPublicFolderInFavorites = function () {
            if (_this.props.isPublicFolder) {
                return isPublicFolderInFavorites(_this.props.folderId);
            }
            return isFolderInFavorites(_this.props.folderId);
        };
        _this.onClick = function (evt) {
            evt.stopPropagation();
            selectFolder(_this.props.folderId, _this.props.treeType, 'FolderNodeClick' /* actionSource */, _this.props.isPublicFolder
                ? 6 /* PublicFolder */
                : 0 /* Folder */);
        };
        _this.onKeyDown = function (evt) {
            switch (evt.keyCode) {
                case 13 /* Enter */:
                case 32 /* Space */:
                    evt.stopPropagation();
                    selectFolder(_this.props.folderId, _this.props.treeType, 'Keyboard' /* actionSource */);
                    break;
            }
        };
        _this.computedState = new FolderNodeComputedState(_this.props);
        return _this;
    }
    FolderNode.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return !shallowCompare(this.props, nextProps);
    };
    FolderNode.prototype.render = function () {
        var _this = this;
        var shouldShowBulkActionsSpinner = isBulkActionRunning(this.props.folderId) ||
            isBulkActionUninitialized(this.props.folderId);
        var shouldRenderUnreadOrTotalCount = !isArchiveFolder(this.props.folderId) && !shouldShowBulkActionsSpinner;
        return (React.createElement(TreeNode, { chevronProps: this.props.chevronProps, customIcon: this.props.customIcon, depth: this.props.depth, displayName: this.props.displayName, isBeingDragged: this.props.isBeingDragged, isDroppedOver: this.props.isDroppedOver, isRootNode: false, isSelected: this.computedState.isSelected, isWithContextMenuOpen: this.computedState.isWithContextMenuOpen, key: this.props.folderId, onKeyDown: this.onKeyDown, onClick: this.onClick, onContextMenu: this.props.onContextMenu, renderCustomTreeNodeDisplay: this.props.renderCustomTreeNodeDisplay, renderRightCharm: shouldRenderUnreadOrTotalCount
                ? this.renderUnreadOrTotalCount
                : shouldShowBulkActionsSpinner
                    ? this.renderBulkActionSpinner
                    : null, renderRightCharmHover: function () {
                return _this.renderRightCharmHover(shouldShowBulkActionsSpinner);
            }, showAsHoverOnDroppedOver: this.props.showHoverStateOnDroppedOver }));
    };
    FolderNode = tslib_1.__decorate([
        observer
    ], FolderNode);
    return FolderNode;
}(React.Component));
export default FolderNode;
//# sourceMappingURL=FolderNode.js.map